// This polyfill is needed for @radix-ui/popover to work in old browsers

// source: https://github.com/JakeChampion/polyfill-service/blob/main/polyfill-libraries/3.111.0/globalThis/min.js

!function(){function e(e){return e&&e.Object==Object&&e}var t=e("object"==typeof c&&c),o=e("object"==typeof window&&window),b=e("object"==typeof self&&self),l=e("object"==typeof global&&global),c=t||o||b||l||Function("return this")();try{Object.defineProperty(c,"globalThis",{configurable:!0,enumerable:!1,writable:!0,value:c})}catch(n){c.globalThis=c}}();
